'use client'

import { memo } from 'react'
import { useLandingCarouselFirstDemoSrc } from '@/lib/cms/use-landing-carousel-first-demo-src'
import { Ninxl8BitDesktopScene } from './ninxl-8bit-desktop-scene'
import { NinxlHeroDemoPlayer } from './ninxl-hero-demo-player'

export const NinxlScrollWorldDemo = memo(function NinxlScrollWorldDemo() {
  // baby: Section Play demo = first published carousel slide (same order as demos carousel).
  const demoSrc = useLandingCarouselFirstDemoSrc('ninxl')

  return (
    <section
      data-section="demo"
      className="ninxl-scroll-world-demo relative z-20 py-12 md:py-16"
      aria-label="NINX hero demo"
    >
      <div className="mx-auto max-w-4xl px-6">
        <div className="ninxl-8bit-label ninxl-theme-text-accent mb-6 text-center tracking-[0.2em]">
          WATCH NINX
        </div>
        <div className="ninxl-pixel-border ninxl-theme-bg-frame relative overflow-hidden">
          <div className="relative aspect-[16/9] w-full min-h-[220px] md:min-h-[360px]">
            <Ninxl8BitDesktopScene />
            <div className="ninxl-crt-overlay pointer-events-none absolute inset-0" />
            <NinxlHeroDemoPlayer
              variant="8bit"
              className="ninxl-hero-demo-on-monitor"
              demoSrc={demoSrc}
              ariaLabel="Play NINX hero demo"
            />
          </div>
        </div>
      </div>
    </section>
  )
})